export default __webpack_public_path__ + "static/media/visa.e4689ece.svg";